import { render } from "./SuccessArea.vue?vue&type=template&id=7d15656a"
import script from "./SuccessArea.vue?vue&type=script&lang=js"
export * from "./SuccessArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__